import { render } from "./SportHighlights.vue?vue&type=template&id=1f2cbe9e&scoped=true"
import script from "./SportHighlights.vue?vue&type=script&lang=js"
export * from "./SportHighlights.vue?vue&type=script&lang=js"

import "./SportHighlights.vue?vue&type=style&index=0&id=1f2cbe9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2cbe9e"]])

export default __exports__